import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import sortAscIcon from '../../../../commons/src/assets/icons/sort-asc.svg'
import sortDescIcon from '../../../../commons/src/assets/icons/sort-desc.svg'
import sortIcon from '../../../../commons/src/assets/icons/sort.svg'

import Icon from '../../../../commons/src/components/icon'

type Props = Overwrite<
  CommonProps<'div' | 'button'>,
  {
    children?: React.ReactNode
    width?: number | string
    computedWidth?: string
    align?: 'left' | 'center' | 'right'
    sort?: 'asc' | 'desc'
    onClick?: React.MouseEventHandler
    groupChild?: boolean
    firstCell?: boolean
    lastCell?: boolean
    noBorder?: boolean
  }
>

const sortIconMap = {
  asc: sortAscIcon,
  desc: sortDescIcon,
}

const TableHeaderCell = ({
  className,
  children,
  computedWidth: width,
  align = 'left',
  sort,
  onClick,
  firstCell = false,
  lastCell = false,
  noBorder = false,
}: Props) => {
  const sortable = !!onClick
  const RootNode = sortable ? 'button' : 'div'

  const sharedProps = {
    className: cn(
      'TableHeaderCell',
      {
        [`align-${align}`]: !!align,
        fixed: !!width && width.includes('px'),
        sortable,
        sort: !!sort,
        firstCell,
        lastCell,
        noBorder,
      },
      className
    ),
    style: {width},
  }

  const buttonProps = sortable
    ? {
        type: 'button' as React.ButtonHTMLAttributes<HTMLButtonElement>['type'],
        onClick,
      }
    : {}

  return (
    <RootNode {...sharedProps} {...buttonProps}>
      <span className="TableHeaderCell__content">{children}</span>
      {sortable && (
        <span className="TableHeaderCell__sort">
          <Icon source={sort ? sortIconMap[sort] : sortIcon} />
        </span>
      )}
    </RootNode>
  )
}

export default TableHeaderCell
